(function () {
  const SELECTOR = "[data-free-gift-promo]";
  let isRunning = false;
  let debounceTimer = null;

  async function fetchCart() {
    const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
      headers: { Accept: "application/json" }
    });

    if (!response.ok) {
      throw new Error(`Cart could not be fetched: ${response.status}`);
    }

    return response.json();
  }

  function getConfig(wrapper) {
    return {
      giftVariantId: Number(wrapper.dataset.giftVariantId),
      requiredCollection: wrapper.dataset.requiredCollection,
      minAmount: Number(wrapper.dataset.minAmount)
    };
  }

  function getGiftLine(cart, giftVariantId) {
    return cart.items.find((item) => item.variant_id === giftVariantId);
  }

  function getEligibleSubtotal(cart, config) {
    return cart.items.reduce((total, item) => {
      if (item.variant_id === config.giftVariantId) return total;

      const hasCollectionProperty =
        item.properties &&
        item.properties._free_gift_collection === config.requiredCollection;

      if (!hasCollectionProperty) return total;

      return total + item.final_line_price;
    }, 0);
  }

  function formatMoney(cents) {
    return `€${(cents / 100).toFixed(2).replace(".", ",")}`;
  }

  async function addGift(wrapper) {
    const config = getConfig(wrapper);
    const button = wrapper.querySelector("[data-free-gift-add]");

    if (button) {
      button.disabled = true;
      button.textContent = "Toevoegen...";
    }

    await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({
        items: [
          {
            id: config.giftVariantId,
            quantity: 1,
            properties: {
              _free_gift: "true"
            }
          }
        ]
      })
    });

    window.location.reload();
  }

  async function removeGift(giftLine) {
    await fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({
        id: giftLine.key,
        quantity: 0
      })
    });

    window.location.reload();
  }

  function render(wrapper, cart) {
    const config = getConfig(wrapper);
    const giftLine = getGiftLine(cart, config.giftVariantId);
    const eligibleSubtotal = getEligibleSubtotal(cart, config);
    const qualifies = eligibleSubtotal >= config.minAmount;
    const remaining = Math.max(config.minAmount - eligibleSubtotal, 0);

    if (giftLine && !qualifies) {
      removeGift(giftLine);
      return;
    }

    if (giftLine && giftLine.quantity > 1) {
      removeGift(giftLine);
      return;
    }

    if (giftLine && qualifies) {
      wrapper.innerHTML = `
        <p class="free-gift-promo__title">Gratis cadeau toegevoegd</p>
        <p class="free-gift-promo__text">Je gratis luchtfilter is toegevoegd aan je winkelwagen.</p>
        <p class="free-gift-promo__small">De korting wordt automatisch toegepast bij checkout.</p>
      `;
      return;
    }

    if (qualifies) {
      wrapper.innerHTML = `
        <p class="free-gift-promo__title">Je hebt recht op een gratis cadeau</p>
        <p class="free-gift-promo__text">Voeg gratis het luchtfilter element toe aan je winkelwagen.</p>
        <button type="button" class="free-gift-promo__button" data-free-gift-add>
          Gratis cadeau toevoegen
        </button>
      `;
      return;
    }

    wrapper.innerHTML = `
      <p class="free-gift-promo__title">Gratis luchtfilter vanaf €20</p>
      <p class="free-gift-promo__text">
        Voeg nog ${formatMoney(remaining)} toe uit de Piaggio Zip II SP1/SP2 collectie om je cadeau te krijgen.
      </p>
    `;
  }

  async function initFreeGift() {
    if (isRunning) return;

    const wrappers = document.querySelectorAll(SELECTOR);
    if (!wrappers.length) return;

    isRunning = true;

    try {
      const cart = await fetchCart();
      wrappers.forEach((wrapper) => render(wrapper, cart));
    } catch (error) {
      console.error("[Free gift promo]", error);
    } finally {
      isRunning = false;
    }
  }

  function debouncedInit() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(initFreeGift, 400);
  }

  document.addEventListener("click", function (event) {
    const button = event.target.closest("[data-free-gift-add]");
    if (!button) return;

    const wrapper = button.closest(SELECTOR);
    if (!wrapper) return;

    addGift(wrapper);
  });

  document.addEventListener("DOMContentLoaded", initFreeGift);

  document.addEventListener("cart:updated", debouncedInit);
  document.addEventListener("cart:refresh", debouncedInit);
  document.addEventListener("ajaxCart:updated", debouncedInit);
})();